/**
 * Created by Ning Jiang on 11/24/2016.
 */

import {ISoundConfig} from "@nolimitcity/slot-game/bin/core/resource/sound/ISoundConfig";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {WinRatioType} from "@nolimitcity/slot-game/bin/core/winpresentation/WinRatio";

export class DeadwoodSoundConfig implements ISoundConfig {

    public static instance:DeadwoodSoundConfig = new DeadwoodSoundConfig();


    AS_WIN:string = "asWin";
    AS_WIN_BIG:string = "asWinBig";

    MAIN_GAME_AMBIANCE:string = "background-music-main";

    FS_SELECT:string = "fsSelect";
    FS_INTRO_AMBIANCE:string = "background-music-fs-intro";
    FS_AMBIANCE:string = "background-music-fs";
    FS_ENDS:string = "fsEnds";
    FS_ENDS_NO_WIN:string = "fsEndsNoWin";

    // REELS_SPIN_START?:string[];
    // REELS_SPINNING:string = "reelsSpinning";
    REELS_SPINNING_START_ON_SPIN_START:string = "reelsSpinning";
    REELS_DEFAULT_BOUNCE:string[] = ["reelLanding1", "reelLanding2", "reelLanding3", "reelLanding4", "reelLanding5"];
    // REELS_DEFAULT_STOP?:string[];

    SHOOT_WINDOW_2:string = "shootWindow1";
    SHOOT_WINDOW_1:string = "shootWindow2";
    SHOOT_WINDOW_EMPTY:string = "shootWindowEmpty";

    WIN_TINY:string = "winTiny";
    WIN_SMALL:string = "winSmall";
    WIN_MEDIUM:string = "winMedium";
    WIN_LARGE:string = "winLarge";

    COUNT_UP:string = "countup";
    COUNT_UP_ENDS:string = "countupEnds";
    COUNT_UP_MULTIPLIER:string = "countupMultiplier";
    COUNT_UP_MULTIPLIER_END:string = "countupMultiplierEnds";

    BIG_WIN_INITIAL_LINE_1:string = "bigwinInitialWinWinLine1";
    BIG_WIN_INITIAL_LINE_2:string = "bigwinInitialWinWinLine2";
    BIG_WIN_INITIAL:string = "bigwinInitialWin";
    BIG_WIN:string = "bigwin";
    BIG_WIN_0:string = "bigwinLevel1";
    BIG_WIN_1:string = "bigwinLevel2";
    BIG_WIN_2:string = "bigwinLevel3";
    BIG_WIN_3:string = "bigwinLevel4";
    BIG_WIN_ENDS:string = "bigwinEnds";
    BIG_WIN_COUNT_UP:string = "bigwinCountup";
    ANTICIPATION_BIG_WIN:string = "anticipationBigwin";

    MULTIPLIER_FIRE:string = "multiplierFire";
    KNIFE:string = "knife";

    WILD_LANDING:string = "wildLanding";
    WILD_NUDGE_3:string = "wildNudge1";
    WILD_NUDGE_2:string = "wildNudge2";
    WILD_NUDGE_1:string = "wildNudge3";
    WILD_NUDGE_ABORT:string = "wildNudgeAbort";

    SCATTER_LANDING_1:string = "scatter1";
    SCATTER_LANDING_2:string = "scatter2";
    SCATTER_LANDING_3:string = "scatter3";
    ANTICIPATION_SCATTER:string = "anticipationScatter";
    ANTICIPATION_SCATTER_FAIL:string = "anticipationScatterFail";
    SCATTER_HIGHLIGHT:string = "scatterHiglight";
    SUPER_HIGHLIGHT:string = "superHiglight";

    START_LANDING_1:string = "star1";
    START_LANDING_2:string = "star2";
    START_LANDING_2_SUPER:string = "star2Super";
    PLUS_SPIN:string = "plusSpin";
    ANTICIPATION_STAR:string = "anticipationStar";
    ANTICIPATION_STAR_FAIL:string = "anticipationStarFail";
    WILD_LIGHT_UP_1:string = "wildLightUp1";
    WILD_LIGHT_UP_2:string = "wildLightUp2";
    SHOOT_OUT_FIRE:string = "shootOutFire";
    SHOOT_OUT_INTRO:string = "shootOutIntro";

    PAPER_1:string = "paper1";
    PAPER_2:string = "paper2";

    SIGN_IDLE:string = "sign";

    GUN_SOUNDS:string[] = ["gun1", "gun2", "gun3", "gun4", "gun5", "gun6"];

    private static _lastGunShotIndex:number;

    constructor() {
        if(DeadwoodSoundConfig.instance) {
            throw new Error("DeadwoodSoundConfig.constructor() - Instantiation failed: Singleton.");
        }
    }

    public static getNormalWinSoundName(type:WinRatioType):string | null {
        switch(type) {
            case WinRatioType.TINY:
                return DeadwoodSoundConfig.instance.WIN_TINY;
            case WinRatioType.SMALL:
                return DeadwoodSoundConfig.instance.WIN_SMALL;
            case WinRatioType.MEDIUM:
                return DeadwoodSoundConfig.instance.WIN_MEDIUM;
            case WinRatioType.LARGE:
                return DeadwoodSoundConfig.instance.WIN_LARGE;
            default:
                return null;
        }
    }

    public static playBigWinInitialLineSound(index:number):void {
        SlotGame.sound.playEffect(index % 2 > 0 ? DeadwoodSoundConfig.instance.BIG_WIN_INITIAL_LINE_2 : DeadwoodSoundConfig.instance.BIG_WIN_INITIAL_LINE_1);
    }

    public static playBustedWildLandingSound(reelId:number):void {
        SlotGame.sound.playEffect(reelId % 2 > 0 ? DeadwoodSoundConfig.instance.WILD_LIGHT_UP_1 : DeadwoodSoundConfig.instance.WILD_LIGHT_UP_2);
    }

    public static playPaperSound(index:number):void {
        SlotGame.sound.playEffect(index % 2 > 0 ? DeadwoodSoundConfig.instance.PAPER_2 : DeadwoodSoundConfig.instance.PAPER_1);
    }

    public static playGunSound():void {
        let index:number = Math.floor(Math.random() * 5);
        while(index === this._lastGunShotIndex) {
            index = Math.floor(Math.random() * 5);
        }
        SlotGame.sound.playEffect(DeadwoodSoundConfig.instance.GUN_SOUNDS[index]);
        this._lastGunShotIndex = index;
    }
}